import { render } from "./ProspectProperty.vue?vue&type=template&id=ebf2c51e"
import script from "./ProspectProperty.vue?vue&type=script&lang=js"
export * from "./ProspectProperty.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__